function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M55 6.35014e-06L0 55L55 110L110 55L55 6.35014e-06Z",
  fill: "#005885"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M55.1524 66.3752C49.4064 66.3752 44.7114 61.7037 44.7114 55.9343C44.7114 50.1649 49.383 45.4933 55.1524 45.4933C60.9218 45.4933 65.5934 50.1649 65.5934 55.9343C65.5934 61.7037 60.9218 66.3752 55.1524 66.3752ZM55.1524 47.4787C50.4808 47.4787 46.6968 51.286 46.6968 55.9343C46.6968 60.5825 50.5042 64.3898 55.1524 64.3898C59.8006 64.3898 63.608 60.5825 63.608 55.9343C63.608 51.286 59.8006 47.4787 55.1524 47.4787Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M54.0313 60.8629C53.7744 60.8629 53.5175 60.7694 53.3306 60.5826L49.9671 57.219C49.5933 56.8453 49.5933 56.2146 49.9671 55.8176C50.3408 55.4438 50.9715 55.4438 51.3685 55.8176L54.0313 58.4804L59.4971 53.0146C59.8708 52.6409 60.5015 52.6409 60.8986 53.0146C61.2723 53.3883 61.2723 54.019 60.8986 54.4161L54.7321 60.5826C54.5452 60.7694 54.2883 60.8629 54.0313 60.8629Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M55.1759 79.8061C54.1715 79.8061 53.2138 79.5024 52.3963 78.9185C46.9305 75.0644 34.1304 63.7125 33.1727 41.5225C33.1494 40.705 33.4297 39.9575 33.9903 39.3502C34.691 38.6261 35.7187 38.2524 36.7698 38.3925C37.9845 38.5327 39.1757 38.6261 40.3436 38.6261C44.478 38.6261 50.0605 37.6685 53.097 33.1604C53.5642 32.483 54.335 32.0626 55.1525 32.0626C55.97 32.0626 56.7408 32.4596 57.208 33.1604C60.2679 37.6685 65.8271 38.6261 69.9614 38.6261C71.1293 38.6261 72.3439 38.5561 73.5352 38.3925C74.5863 38.2758 75.5906 38.6261 76.2914 39.3502C76.852 39.9575 77.1556 40.7283 77.1323 41.5459C76.1746 63.7592 63.3511 75.0878 57.8854 78.9418C57.0912 79.5024 56.1335 79.8061 55.1525 79.8061H55.1759ZM36.3494 40.3313C35.9757 40.3313 35.6487 40.4714 35.4151 40.7283C35.2749 40.8685 35.1348 41.1021 35.1348 41.4524C36.0458 62.7782 48.2853 73.6396 53.5175 77.3301C54.4751 78.0075 55.8299 78.0309 56.7642 77.3535C61.9964 73.6863 74.2592 62.8249 75.1702 41.4991C75.1702 41.1488 75.0301 40.8918 74.8899 40.7517C74.6096 40.4714 74.2125 40.3313 73.7921 40.378C72.5074 40.5415 71.2227 40.6115 69.9614 40.6115C65.3599 40.6115 59.1 39.5137 55.5729 34.2816C55.4328 34.0947 55.2459 34.048 55.1525 34.048C55.0591 34.048 54.8722 34.0713 54.7321 34.2816C51.1817 39.5137 44.9451 40.6115 40.3436 40.6115C39.0823 40.6115 37.7976 40.5415 36.5129 40.378C36.4662 40.378 36.3961 40.378 36.3494 40.378V40.3313Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M40.2968 44.1152C40.2968 44.7459 39.7829 45.2364 39.1756 45.2364C38.5683 45.2364 38.0544 44.7225 38.0544 44.1152C38.0544 43.5079 38.5683 42.994 39.1756 42.994C39.7829 42.994 40.2968 43.5079 40.2968 44.1152Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M56.2736 39.6071C56.2736 40.2377 55.7597 40.7283 55.1524 40.7283C54.5451 40.7283 54.0312 40.2144 54.0312 39.6071C54.0312 38.9998 54.5451 38.4859 55.1524 38.4859C55.7597 38.4859 56.2736 38.9998 56.2736 39.6071Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M56.2736 74.0133C56.2736 74.644 55.7597 75.1345 55.1524 75.1345C54.5451 75.1345 54.0312 74.6206 54.0312 74.0133C54.0312 73.406 54.5451 72.8922 55.1524 72.8922C55.7597 72.8922 56.2736 73.406 56.2736 74.0133Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M70.0081 44.1152C70.0081 44.7459 70.5219 45.2364 71.1292 45.2364C71.7365 45.2364 72.2504 44.7225 72.2504 44.1152C72.2504 43.5079 71.7365 42.994 71.1292 42.994C70.5219 42.994 70.0081 43.5079 70.0081 44.1152Z",
  fill: "white"
});

function SvgA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/a.35aefb51.svg";
export { ForwardRef as ReactComponent };